import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status',
})
export class StatusPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    // if null is passed as fallback, it will return null. This is desired in cases where the component wants to handle missing value.
    const fallbackValue = args?.[0] === undefined ? 'NO STATUS' : args[0];
    if (typeof value !== 'string') {
      return fallbackValue;
    }

    return value.replace('_', ' ').toUpperCase();
  }
}
